import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'

import { updateUser } from '../services'
import { handleError } from '../../../helpers'

export default function EditUserModal({ visible, onClose, user, reload }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			name: user.name,
			document: user.document,
			role: user.role
		}
	})

	const onSubmit = values => {
		setLoading(true)
		if(user.document === parseInt(values.document)) delete values.document
		if(!values.password) delete values.password

		updateUser(user.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Actualizar Usuario</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<Form.Group className='form-group'>
							<Form.Label>Nombre Completo <span className='text-danger'>*</span></Form.Label>
							<Form.Control 
								{...register('name', { required:true })}
								placeholder='Escriba aquí...'
							/>
							{ errors.name && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
						</Form.Group>
						<Form.Group className='form-group'>
							<Form.Label>Documento <span className='text-danger'>*</span></Form.Label>
							<Form.Control 
								{...register('document', { required:true })}
								placeholder='Escriba aquí...'
								type="number"
							/>
							{ errors.document && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
						</Form.Group>
						<Form.Group className='form-group'>
							<Form.Label>Rol <span className='text-danger'>*</span></Form.Label>
							<Form.Control 
								as="select"
								{...register('role', { required:true })}
							>
								<option value="">:: Seleccionar una opción ::</option>
								<option value="admin">Administrador</option>
								<option value="jefatura">Jefatura</option>
								<option value="gestor_citas">Gestor de Citas</option>
							</Form.Control>
							{ errors.role && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
						</Form.Group>
						<Row>
							<Form.Group as={Col} className='form-group'>
								<Form.Label>Contraseña <small>(opcional)</small></Form.Label>
								<Form.Control 
									type="password"
									{...register('password', {})}
									placeholder='Escriba solo para cambiar'
								/>
							</Form.Group>
							<Form.Group as={Col} className='form-group'>
								<Form.Label>Confirmar Contraseña</Form.Label>
								<Form.Control 
									type="password"
									{...register('password_confirmation', {})}
									placeholder='Escriba solo para cambiar'
								/>
							</Form.Group>
						</Row>
						<Button color="primary" type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-5' /> }
							Actualizar Usuario
						</Button>						
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}